

import React, { forwardRef, useImperativeHandle, useState, useRef, useEffect, useMemo } from 'react';
// import logoImage from '../../../image/LinkLogo.png';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import lodash, { subtract } from 'lodash';
import FetchModule from '../../Model/Network/FetchModule';

// import HomeImagePath from '../../../image/Home.png';
// import MemberImagePath from '../../../image/Member.png';
// import ClassImagePath from '../../../image/Class.png';
// import ChartImagePath from '../../../image/Chart.png';
// import LockerImagePath from '../../../image/Locker.png';
// import BoardImagePath from '../../../image/Board.png';
// import NavNoticeImagePath from '../../../image/NavNotice.png';
// import NoteImagePath from '../../../image/Note.png';
// import NavSettingImagePath from '../../../image/NavSetting.png';

// import HoverHomeImagePath from '../../../image/HoverHome.png';
// import HoverMemberImagePath from '../../../image/HoverMember.png';
// import HoverClassImagePath from '../../../image/HoverClass.png';
// import HoverChartImagePath from '../../../image/HoverChart.png';
// import HoverLockerImagePath from '../../../image/HoverLocker.png';
// import HoverBoardImagePath from '../../../image/HoverBoard.png';
// import HoverNavNoticeImagePath from '../../../image/HoverNavNotice.png';
// import HoverNoteImagePath from '../../../image/HoverNote.png';
// import HoverNavSettingImagePath from '../../../image/HoverNavSetting.png';

// import ClickHomeImagePath from '../../../image/ClickHome.png';
import MemberImagePath from '../../Image/ClickMember.png';
import NoteImagePath from '../../Image/ClickNote.png';
import SettingImagePath from '../../Image/ClickNavSetting.png';

// import ClickClassImagePath from '../../../image/ClickClass.png';
// import ClickChartImagePath from '../../../image/ClickChart.png';
// import ClickLockerImagePath from '../../../image/ClickLocker.png';
// import ClickBoardImagePath from '../../../image/ClickBoard.png';
// import ClickNavNoticeImagePath from '../../../image/ClickNavNotice.png';
// import ClickNoteImagePath from '../../../image/ClickNote.png';
// import ClickNavSettingImagePath from '../../../image/ClickNavSetting.png';

const NavigationBar = forwardRef((props, ref) => {
  const {
    nowPage,
    setNowPage,
    defaultURL,
    tournamentColumns,
    setTournamentColumns,
    subTextInput,
    isClickedModify
  } = props;

  const navigate = useNavigate();

  const [index, setIndex] = useState(0);
  const [nowPageKey, setNowPageKey] = useState('홈');
  const [path, setPath] = useState('');

  const location = useLocation(); // URL 감지용

  //useImperativeHandle(ref, () => ({
  //}));

  const [originalNavInfo] = useState(() => ([{
    buttonRef: React.createRef(),
    img: '',
    text: "STEP.1 홈",
    imgRef: React.createRef(),
    textRef: React.createRef(),
    subRef: React.createRef(),
    children: [{
      btnRef: React.createRef(),
      subText: "+",
      organizerId: 0
    }],
    destination: ['/main'],
  },
  {
    buttonRef: React.createRef(),
    img: '',
    text: "STEP.2 신청",
    imgRef: React.createRef(),
    textRef: React.createRef(),
    subRef: React.createRef(),
    children: [],
    destination: ['/event'],
  },
  {
    buttonRef: React.createRef(),
    img: '',
    text: "STEP.3 상품",
    imgRef: React.createRef(),
    textRef: React.createRef(),
    subRef: React.createRef(),
    children: [],
    destination: ['/product'],
  },
  {
    buttonRef: React.createRef(),
    img: '',
    text: "STEP.4 약관",
    imgRef: React.createRef(),
    textRef: React.createRef(),
    subRef: React.createRef(),
    children: [],
    destination: ['/terms'],
  },
  {
    buttonRef: React.createRef(),
    img: MemberImagePath,
    text: "인원",
    imgRef: React.createRef(),
    textRef: React.createRef(),
    subRef: React.createRef(),
    children: [],
    destination: ['/unit'],
  },
  {
    buttonRef: React.createRef(),
    img: NoteImagePath,
    text: "노트",
    imgRef: React.createRef(),
    textRef: React.createRef(),
    subRef: React.createRef(),
    children: [],
    destination: ['/note'],
  },
  {
    buttonRef: React.createRef(),
    img: SettingImagePath,
    text: "설정",
    imgRef: React.createRef(),
    textRef: React.createRef(),
    subRef: React.createRef(),
    children: [],
    destination: ['/setting'],
  }]), []);

  const [NavInfo, setNavInfo] = useState(originalNavInfo);

  const tournamentBtnRefs = useMemo(() => tournamentColumns.map(() => React.createRef()), [tournamentColumns]);
  const eventBtnRefs = useMemo(() => tournamentColumns.map(() => React.createRef()), [tournamentColumns]);
  const productBtnRefs = useMemo(() => tournamentColumns.map(() => React.createRef()), [tournamentColumns]);
  const termsBtnRefs = useMemo(() => tournamentColumns.map(() => React.createRef()), [tournamentColumns]);
  const unitBtnRefs = useMemo(() => tournamentColumns.map(() => React.createRef()), [tournamentColumns]);
  const noteBtnRefs = useMemo(() => tournamentColumns.map(() => React.createRef()), [tournamentColumns]);
  const settingBtnRefs = useMemo(() => tournamentColumns.map(() => React.createRef()), [tournamentColumns]);

  useEffect(() => {
    let newNavInfo = lodash.cloneDeep(originalNavInfo);
    let organizerInfoChildren = [];
    let organizerDestinations = [];
    let eventInfoChildren = [];
    let eventDestinations = [];
    let productInfoChildren = [];
    let productDestinations = [];
    let termsInfoChildren = [];
    let termsDestinations = [];
    let unitInfoChildren = [];
    let unitDestinations = [];
    let noteInfoChildren = [];
    let noteDestinations = [];
    let settingInfoChildren = [];
    let settingDestinations = [];

    // console.log(tournamentColumns);
    for (let i = 0; i < tournamentColumns.length; i++) {
      organizerInfoChildren.push({
        btnRef: tournamentBtnRefs[i],
        subText: tournamentColumns[i].columnText,
        organizerId: tournamentColumns[i].organizerId
      })

      organizerDestinations.push('/main/' + tournamentColumns[i].organizerId);

      if (tournamentColumns[i].organizerId !== 0) {
        eventInfoChildren.push({
          btnRef: eventBtnRefs[i],
          subText: tournamentColumns[i].columnText
        })

        productInfoChildren.push({
          btnRef: productBtnRefs[i],
          subText: tournamentColumns[i].columnText
        })

        termsInfoChildren.push({
          btnRef: termsBtnRefs[i],
          subText: tournamentColumns[i].columnText
        })

        unitInfoChildren.push({
          btnRef: unitBtnRefs[i],
          subText: tournamentColumns[i].columnText
        })

        noteInfoChildren.push({
          btnRef: noteBtnRefs[i],
          subText: tournamentColumns[i].columnText
        })

        settingInfoChildren.push({
          btnRef: settingBtnRefs[i],
          subText: tournamentColumns[i].columnText
        })

        eventDestinations.push('/ticket/' + tournamentColumns[i].organizerId);
        productDestinations.push('/product/' + tournamentColumns[i].organizerId);
        termsDestinations.push('/terms/' + tournamentColumns[i].organizerId);
        unitDestinations.push('/unit/' + tournamentColumns[i].organizerId);
        noteDestinations.push('/note/' + tournamentColumns[i].organizerId);
        settingDestinations.push('/setting/' + tournamentColumns[i].organizerId);
      }
    }

    newNavInfo[0].children = organizerInfoChildren;
    newNavInfo[0].destination = organizerDestinations;
    newNavInfo[1].children = eventInfoChildren;
    newNavInfo[1].destination = eventDestinations;
    newNavInfo[2].children = productInfoChildren;
    newNavInfo[2].destination = productDestinations;
    newNavInfo[3].children = termsInfoChildren;
    newNavInfo[3].destination = termsDestinations;
    newNavInfo[4].children = unitInfoChildren;
    newNavInfo[4].destination = unitDestinations;
    newNavInfo[5].children = noteInfoChildren;
    newNavInfo[5].destination = noteDestinations;
    newNavInfo[6].children = settingInfoChildren;
    newNavInfo[6].destination = settingDestinations;

    setNavInfo(newNavInfo);
  }, [originalNavInfo, tournamentColumns])

  useEffect(() => {
    let path = location.pathname;

    if (path.includes('/main')) {
      setNowPageKey('STEP.1 홈');
      setIndex(0);
    }
    if (path.includes('/event')) {
      setNowPageKey('STEP.2 신청');
      setIndex(1);
    }
    else if (path.includes('/product')) {
      setNowPageKey('STEP.3 상품');
      setIndex(2)
    }
    else if (path.includes('/terms')) {
      setNowPageKey('STEP.4 약관');
      setIndex(3);
    }
    else if (path.includes('/unit')) {
      setNowPageKey('인원');
      setIndex(4);
    }
    else if (path.includes('/note')) {
      setNowPageKey('노트');
      setIndex(5);
    }
    else if (path.includes('/setting')) {
      setNowPageKey('설정');
      setIndex(6);
    }

    setNowPage(defaultURL + location.pathname);
    setPath(location.pathname);
  }, [location])

  useEffect(() => {
    for (let i = 0; i < NavInfo.length; i++) {
      if (index !== i) {
        if (NavInfo[i].textRef.current !== null && NavInfo[i].textRef.current !== undefined) NavInfo[i].textRef.current.style.color = `#FFFFFF`;
        if (NavInfo[i].buttonRef.current !== null && NavInfo[i].buttonRef.current !== undefined) NavInfo[i].buttonRef.current.style.backgroundColor = `#000000`;
      }
    }

    if (NavInfo[index].textRef.current !== null && NavInfo[index].textRef.current !== undefined) NavInfo[index].textRef.current.style.color = `#FFFFFF`;
    if (NavInfo[index].buttonRef.current !== null && NavInfo[index].buttonRef.current !== undefined) NavInfo[index].buttonRef.current.style.backgroundColor = `#6DD49E`;

    // if (NavInfo[index].subRef.current !== null && NavInfo[index].text === 'STEP.2 신청') NavInfo[index].subRef.current.style.height = (48 * eventColumns.length) + 'px';

    // if (NavInfo[index].subRef.current !== null
    //   && (NavInfo[index].text === 'STEP.1 홈'
    //     || NavInfo[index].text === 'STEP.2 신청')) {
    //   setTimeout(() => {
    //     NavInfo[index].subRef.current.style.height = `${48 * tournamentColumns.length}px`;
    //   }, 30);
    // }

    if (NavInfo[index].subRef.current !== null) {
      if (NavInfo[index].text === 'STEP.1 홈') {
        //setTimeout(() => {
        //  NavInfo[index].subRef.current.style.height = `${48 * tournamentColumns.length}px`;
        //}, 30);
          NavInfo[index].subRef.current.style.height = `${48 * tournamentColumns.length}px`;
      }
      // else if (NavInfo[index].text === 'STEP.2 신청') {
      else {
        if (tournamentColumns.length === 0) {
          //setTimeout(() => {
          //  NavInfo[index].subRef.current.style.height = `${48 * tournamentColumns.length}px`;
          //}, 30);
            NavInfo[index].subRef.current.style.height = `${48 * tournamentColumns.length}px`;
        }
        else {
          //setTimeout(() => {
          //  NavInfo[index].subRef.current.style.height = `${48 * (tournamentColumns.length - 1)}px`;
          //}, 30);
            NavInfo[index].subRef.current.style.height = `${48 * (tournamentColumns.length - 1)}px`;
        }
      }
    }

    if (!nowPage.includes('/unit')) {
      window.localStorage.removeItem('UnitApprovalDateSort');
      window.localStorage.removeItem('UnitNowPage');
    }
  }, [NavInfo, index, nowPage, tournamentColumns])

  if (!path.includes('/main')
    && !path.includes('/event')
    && !path.includes('/product')
    && !path.includes('/terms')
    && !path.includes('/unit')
    && !path.includes('/note')
    && !path.includes('/ticket')
    && !path.includes('/setting')) return null;

  // Sub Navigate 버튼 텍스트 색상 결정 //
  function decideSubNavigateButtonTextColor(data, childData, idx) {
    //if (nowPage.includes(data.destination[idx]) || childData.subText === '+') return '#FFFFFF';
  if (nowPage.split("/").pop() === (data.destination[idx].split("/").pop()) || childData.subText === '+') return '#FFFFFF';
    else return '#BEBEBE'
  }

  // Sub Navigate 버튼 색상 결정 //
  function decideSubNavigateButtonBackgroundColor(data, childData, idx) {
    //if (nowPage.includes(data.destination[idx])) return '#6DD49E';
    if (nowPage.split("/").pop() === (data.destination[idx].split("/").pop())) return '#6DD49E';
    else if (childData.subText === '+') return '#1D1D1D';
    else return '#000000'
  }

  // 컬럼텍스트 결정 //
  function decideTournamentColumnText(text, idx) {
    if (text === '') return '새 이벤트 ' + tournamentColumns.length;
    else {
      if (tournamentColumns[idx].organizerId == nowPage.split("/").pop() && isClickedModify) return subTextInput;
      else return text;
    }
  }

  // 호버링 //
  function focusButton(index) {
    if (NavInfo[index].text === 'STEP.1 홈' && NavInfo[index].text !== nowPageKey) {
      NavInfo[index].textRef.current.style.color = `#FFFFFF`;
      NavInfo[index].buttonRef.current.style.backgroundColor = `#6DD49E`;
    }
    else if (NavInfo[index].text === 'STEP.2 신청' && NavInfo[index].text !== nowPageKey) {
      NavInfo[index].textRef.current.style.color = `#FFFFFF`;
      NavInfo[index].buttonRef.current.style.backgroundColor = `#6DD49E`;
    }
    else if (NavInfo[index].text === 'STEP.3 상품' && NavInfo[index].text !== nowPageKey) {
      NavInfo[index].textRef.current.style.color = `#FFFFFF`;
      NavInfo[index].buttonRef.current.style.backgroundColor = `#6DD49E`;
    }
    else if (NavInfo[index].text === 'STEP.4 약관' && NavInfo[index].text !== nowPageKey) {
      NavInfo[index].textRef.current.style.color = `#FFFFFF`;
      NavInfo[index].buttonRef.current.style.background = `#6DD49E`;
    }
    else if (NavInfo[index].text === '인원' && NavInfo[index].text !== nowPageKey) {
      NavInfo[index].textRef.current.style.color = `#FFFFFF`;
      NavInfo[index].buttonRef.current.style.background = `#6DD49E`;
    }
    else if (NavInfo[index].text === '노트' && NavInfo[index].text !== nowPageKey) {
      NavInfo[index].textRef.current.style.color = `#FFFFFF`;
      NavInfo[index].buttonRef.current.style.backgroundColor = `#6DD49E`;
    }
    else if (NavInfo[index].text === '설정' && NavInfo[index].text !== nowPageKey) {
      NavInfo[index].textRef.current.style.color = `#FFFFFF`;
      NavInfo[index].buttonRef.current.style.background = `#6DD49E`;
    }
  }

  // 호버링 //
  function blurButton(index) {
    if (NavInfo[index].text === 'STEP.1 홈' && NavInfo[index].text !== nowPageKey) {
      NavInfo[index].textRef.current.style.color = `#FFFFFF`;
      NavInfo[index].buttonRef.current.style.backgroundColor = `#000000`;
    }
    else if (NavInfo[index].text === 'STEP.2 신청' && NavInfo[index].text !== nowPageKey) {
      NavInfo[index].textRef.current.style.color = `#FFFFFF`;
      NavInfo[index].buttonRef.current.style.backgroundColor = `#000000`;
    }
    else if (NavInfo[index].text === 'STEP.3 상품' && NavInfo[index].text !== nowPageKey) {
      NavInfo[index].textRef.current.style.color = `#FFFFFF`;
      NavInfo[index].buttonRef.current.style.backgroundColor = `#000000`;
    }
    else if (NavInfo[index].text === 'STEP.4 약관' && NavInfo[index].text !== nowPageKey) {
      NavInfo[index].textRef.current.style.color = `#FFFFFF`;
      NavInfo[index].buttonRef.current.style.backgroundColor = `#000000`;
    }
    else if (NavInfo[index].text === '인원' && NavInfo[index].text !== nowPageKey) {
      NavInfo[index].textRef.current.style.color = `#FFFFFF`;
      NavInfo[index].buttonRef.current.style.backgroundColor = `#000000`;
    }
    else if (NavInfo[index].text === '노트' && NavInfo[index].text !== nowPageKey) {
      NavInfo[index].textRef.current.style.color = `#FFFFFF`;
      NavInfo[index].buttonRef.current.style.backgroundColor = `#000000`;
    }
    else if (NavInfo[index].text === '설정' && NavInfo[index].text !== nowPageKey) {
      NavInfo[index].textRef.current.style.color = `#FFFFFF`;
      NavInfo[index].buttonRef.current.style.backgroundColor = `#000000`;
    }
  }

  // 버튼 클릭시 //
  function clickButton(index) {
    setNowPageKey(NavInfo[index].text);
    setIndex(index);

    if (NavInfo[index].children.length === 0) navigate(NavInfo[index].destination[0]);
  }

  // Sub Navigate 버튼 클릭시 //
  function clickSubButton(index, idx) {
    if (NavInfo[index].children[idx].subText === '+') {
      let columns = tournamentColumns.slice();

      // columns.push({ eventId: -1, eventTitle: '이벤트 ' + NavInfo[index].children.length });
      // console.log(columns);
      columns[columns.length - 1].columnText = '새 이벤트 ' + columns.length;

      setTournamentColumns(columns);
    }
    
    navigate(NavInfo[index].destination[idx]);
  }

  return (
    <TopLevelWrapper ref={ref}>
      {
        NavInfo.map((data, index) => (
          <TotalWrapper key={'NavColumn-' + index}>
            <Button ref={data.buttonRef} onClick={() => clickButton(index)} onMouseOver={() => focusButton(index)} onMouseLeave={() => blurButton(index)} >
              {data.img !== '' && <Img img={data.img} hoverImg={data.hoverImg} index={index} />}
              <ButtonText ref={data.textRef}>{data.text}</ButtonText>
            </Button>
            {
              (data.children.length !== 0 && data.text === nowPageKey) &&
              <SubButtonWrapper ref={data.subRef}>
                {
                  data.children.map((childData, idx) => (
                    <SubWrapper key={'NavSubColumn-' + idx}>
                      <SubButton
                        ref={childData.btnRef}
                        backgroundColor={decideSubNavigateButtonBackgroundColor(data, childData, idx)}
                        color={decideSubNavigateButtonTextColor(data, childData, idx)} 
                        onClick={() => clickSubButton(index, idx)}>
                        {
                          childData.subText === '+' ?
                            <PlusWrapper>
                              <Stick width={18} height={2} />
                              <Stick width={2} height={18} />
                            </PlusWrapper>
                            :
                            <SubButtonTextWrapper>
                              <Text 
                                fontFamily={'NotoSansKR-Medium'} 
                                fontSize={'14'} 
                                hover={'pointer'}>
                                {
                                  decideTournamentColumnText(childData.subText, idx)
                                }
                              </Text>
                            </SubButtonTextWrapper>
                        }
                      </SubButton>
                    </SubWrapper>
                  ))
                }
              </SubButtonWrapper>
            }
            {index === 3 && <DivisionLine />}
          </TotalWrapper>
        ))
      }
    </TopLevelWrapper>
  )
})

export default NavigationBar;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-right: 20px;

  width: 120px;
  
  gap: 8px;

  background-color: #000000;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;
`;

const CountComponent = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: -12px;

  width: 24px;
  height: 24px;

  border-radius: 24px;
  background-color: #FF3131;

  :hover {
    cursor: default;
  }
`;

const Button = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 120px;
  height: 48px;
  
  border-radius: 30px;

  // margin-bottom: 8px;

  gap: 16px;

  background-color: #000000;

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
  }
`;

const Img = styled.div`
  display: flex;
  flex-direction: row;

  width: 24px;
  height: 24px;

  justify-content: center;
  align-items: center;

  background: url(${props => props.img}) no-repeat center center;
            
  :hover {
    cursor: pointer;
  }
  
  transition: all 0.3s ease-in-out;
`;

const ButtonText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 18px;

  color: #FFFFFF;

  margin: 0 0 0 0;

  transition: all 0.3s ease-in-out;
`;

const SubButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 10px;

  width: 120px;
  height: 0px;

  border-radius: 24px;

  background-color: #1D1D1D;
  
  overflow: hidden;

  transition: all 0.3s ease-in-out;
`;

const SubWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  width: 100%;
  height: 48px;
`;

const SubButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0px 8px;

  width: 104px;
  height: 48px;

  background-color: ${props => props.backgroundColor};

  color: ${props => props.color};

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
    color: #FFFFFF;
    background-color: #6DD49E;
  }
`;

const SubButtonTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  max-width: 100%;
  height: 20px;

  overflow: hidden;
`;

const PlusWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  // width: 18px;
  // height: 18px;
`;

const Stick = styled.div`
  position: absolute;
  width: ${props => props.width}px;
  height: ${props => props.height}px;

  border-radius: 4px;
  
  background-color: #FFFFFF;
`;

const DivisionLine = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin: 20px 0px 12px 0px;

  width: 100%;
  height: 1px;

  border-radius: 2px;
  background-color: #FFFFFF;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  margin: 0 0 0 0;
  
  :hover {
    cursor: ${props => props.hover};
  }
`;
